



























import FileDrop                                      from "@/components/FileDrop.vue";
import { ButtonAction, PageScheme, StaticFieldType } from "@/components/pageGenerator/models";
import PageGenerator                                 from "@/components/pageGenerator/PageGenerator.vue";
import { Component, Vue }                            from "vue-property-decorator";

@Component({
  name      : "Privacy",
  components: {
    PageGenerator,
    FileDrop
  }
})
export default class Privacy extends Vue {
  private model            = [];
  private Page: PageScheme = {
    backgroundColor: "#ff00ff",
    groups         : [
      {
        title : "Form Group Title",
        fields: [
          {
            type   : StaticFieldType.Headline,
            name   : "Headline",
            content: "Headline Field"
          },
          {
            type   : StaticFieldType.Paragraph,
            name   : "Paragraph",
            content: "Paragraph Field"
          },
          {
            type   : StaticFieldType.Image,
            name   : "Image",
            content: "https://picsum.photos/200/75"
          },
          {
            type   : StaticFieldType.Video,
            name   : "Video",
            content: ""
          },
          {
            type  : StaticFieldType.Button,
            name  : "SendButton",
            action: ButtonAction.Submit,
            label : "Submit"
          },
          {
            type   : StaticFieldType.Button,
            name   : "LinkButton",
            action : ButtonAction.Link,
            label  : "www.a-blok.com",
            content: "http://a-blok.com"
          }
        ]
      }
    ]
  };


  private items = ["Foo", "Bar", "Fizz", "Buzz"];

  handleFiles(fileList: FileList): void {
    for (const item of fileList) {
      console.log(item.name);
    }
  }
}
